<template>
    <div>
        <div id="container">
            <div class="section01">
                <PromiseCard />
                <!-- <GovernanceCard /> -->
                <h3 class="m-visible">자원순환센터</h3>
                <RecycleCard />
            </div>
        </div>
    </div>
</template>

<script>
import PromiseCard from '@/views/biz/PromiseCard.vue';
import GovernanceCard from '@/views/biz/GovernanceCard.vue';
import RecycleCard from '@/views/biz/RecycleCard.vue';

export default {
    name: 'biz',
    components: {
        PromiseCard,
        GovernanceCard,
        RecycleCard,
    },
}
</script>